import { render, staticRenderFns } from "./SuspendUser.vue?vue&type=template&id=492c75a3&"
import script from "./SuspendUser.vue?vue&type=script&lang=js&"
export * from "./SuspendUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports